import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import * as _ from "lodash";

import { URLSearchParams } from '@angular/http'
import { HttpBackendService } from "app/services/http-backend.service";
import { ServiceObject } from "app/models/serviceObject";
import { PagedResult } from "app/models/PagedResult";
import { Call } from "../models/call";
import { CallService } from "./call.service";

@Injectable()
export class VersionService {

  constructor(
    private _http: HttpBackendService
  ) { }

  public getVersionInfo(): Observable<string> {
    return this._http.head("/", null, false)
      .map(response => {
        const serverHeaderPrefix = "Client-Personal-Area-Web/";

        var serverHeaderValues = response.headers.getAll("server");

        if (serverHeaderValues == null)
          return null;

        var serverHeaderValuesArray: string[] = [];

        _.forEach(serverHeaderValues, function (value) {
          serverHeaderValuesArray = serverHeaderValuesArray.concat(value.split(" "));
        });

        var systemInfo = _.find(serverHeaderValuesArray, function (value) {
          return _.startsWith(value, serverHeaderPrefix);
        });

        if (systemInfo == undefined)
          return null;

        return systemInfo.replace(serverHeaderPrefix, "");
      });
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/version.service.ts